<template>
  <div @keyup.enter="enterSearch">
    <el-row class="time-container" type="flex" justify="space-between" align="middle">
      <p>统计时间：{{nowTime}}</p>
      <el-radio-group v-model="timeType" @change="handleTimeTypeChange">
        <el-radio-button
          v-for="item in timeOptions"
          :key="item.value"
          :label="item.value">{{item.name}}</el-radio-button>
      </el-radio-group>
      <el-date-picker
        class="date-picker"
        v-if="timeType !== 0"
        v-model="time"
        @change="handleDateChange"
        :picker-options="pickerOptions"
        :type="timeOptions[timeType].type"
        :placeholder="`选择${timeOptions[timeType].name}`"
        :value-format="timeOptions[timeType].format">
      </el-date-picker>
    </el-row>
    <type-card-list :list="typeCardList" @item-click="handleCardClick"></type-card-list>
    <el-form :model="form" ref="form" label-width="80px" :inline="true">
      <el-form-item label="经营组织" v-if="[3,4].includes(dataType)">
        <ajax-select
          v-model="form.org"
          type="org"
          valueField="obj"
          placeholder="请输入关键词"
          @change="handleOrgChange"></ajax-select>
      </el-form-item>
      <el-form-item label="商品名称" v-if="[4].includes(dataType)">
        <search-select
          v-model="form.pro"
          placeholder="请输入关键词"
          type="product"
          clearable
          ref="proSelect"
          @change="handleProChange"
          :extra-params="{ deptID: form.org && form.org.id, itemType: 1}"></search-select>
      </el-form-item>
    </el-form>
    <div class="echart-line-wrap">
      <echarts-line :series-data="dataList" :extra-option="extraOption"/>
    </div>
    <export-table :columnList="columnList" :list="tableList" @export="batchExport"/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import AjaxSelect from '@/components/ajaxSelect'
import SearchSelect from '@/components/searchSelect'
import ExportTable from '../components/exportTable.vue'
import TypeCardList from '../components/typeCardList'
import EchartsLine from '@/components/echarts'
import { columnMap, cardDataList } from './dataMap'

export default {
  name: 'DataBoardFlowSurvey',
  components: { AjaxSelect, SearchSelect, TypeCardList, ExportTable, EchartsLine },
  data () {
    return {
      nowTime: new Date().toLocaleString(),
      timeType: 0,
      time: '',
      dataType: 0,
      form: {
        org: { id: '', name: '全部' },
        pro: ''
      },
      timeOptions: [
        {
          name: '实时',
          value: 0,
          type: '',
          format: ''
        },
        {
          name: '日',
          value: 1,
          type: 'date',
          format: 'yyyyMMdd'
        },
        {
          name: '月',
          value: 2,
          type: 'month',
          format: 'yyyyMM'
        },
        {
          name: '年',
          value: 3,
          type: 'year',
          format: 'yyyy'
        }
      ],
      visualType: 'line',
      tableList: [],
      xAxisNames: [],
      dataList: [],
      typeCardList: cardDataList,
      pickerOptions: { // 禁用当日，不影响月、年选择
        disabledDate (time) {
          return time.getTime() < Date.now() && time.getTime() > Date.now() - 8.64e7
        }
      }
    }
  },
  computed: {
    columnList () {
      const list = columnMap[this.dataType]
      if (this.isNow || this.isQueueCar) {
        return list
      } else {
        const newList = list.filter((item, index) => index !== list.length - 1) // 去掉昨日列
        return newList.map(item => {
          let label = item.label
          if (item.prop === 'num') {
            const arr = ['', '日', '月', '年']
            label = `当${arr[this.timeType]}${label.slice(2)}`
          }
          return {
            ...item,
            label
          }
        })
      }
    },
    isMissRate () {
      return this.dataType === 2
    },
    extraOption () {
      const obj = {
        title: { text: this.typeCardList[this.dataType].title },
        xAxis: { data: this.xAxisNames }
      }
      if (this.isMissRate) { // 跳失率
        obj.yAxis = {
          axisLabel: {
            formatter: '{value}%'
          }
        }
      }
      return obj
    },
    todayStr () {
      const dateStr = this.nowTime.match(/^[\d/]+/g)
      const dateArr = dateStr[0].split('/')
      const year = dateArr[0]
      const month = dateArr[1] < 10 ? '0' + dateArr[1] : dateArr[1]
      const day = dateArr[2] < 10 ? '0' + dateArr[2] : dateArr[2]
      return year + month + day
    },
    // 实时
    isNow () {
      return this.timeType === 0
    },
    // 排队车辆
    isQueueCar () {
      return this.dataType === 4
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['getDataBoardFlowSurveyList', 'exportDataBoardFlowSurvey']),
    handleOrgChange (v) {
      // 有商品筛选条件时清空商品
      if (this.isQueueCar) {
        this.form.pro = ''
        this.$nextTick(() => {
          this.$refs['proSelect'].initOption()
        })
      }
      this.getData()
    },
    handleProChange (val) {
      if (val) {
        this.getData()
      }
    },
    handleTimeTypeChange (v) {
      this.time = ''
      if (v === 0) {
        this.getData()
      }
    },
    handleDateChange (v) {
      if (v) {
        this.getData()
      }
    },
    handleCardClick (info, index) {
      this.dataType = index
      this.$nextTick(() => {
        if (this.timeType === 0) {
          this.getData()
        } else {
          if (this.time !== '' && this.time !== null) { // 非实时，未选时间不请求
            this.getData()
          } else {
            this.$message.warning('请选择一个日期来搜索数据')
          }
        }
      })
    },
    getData () {
      const params = this.formatParams()
      this.getDataBoardFlowSurveyList(params).then(res => {
        this.tableList = res.list
        this.getVisualLists(res.list)
      }).catch(() => {
        this.tableList = []
        this.dataList = []
      })
    },
    formatParams () {
      const { org, pro } = this.form
      let params = {
        date: this.isNow ? this.todayStr : this.time,
        dateType: this.timeType,
        reportType: this.dataType
      }
      if (this.dataType === 3) {
        params = {
          ...params,
          orgId: org.id,
          orgName: org.name
        }
      }
      if (this.isQueueCar) {
        params = {
          ...params,
          orgId: org.id,
          orgName: org.name,
          itemId: pro.id,
          itemName: pro.name
        }
      }
      return params
    },
    getVisualLists (list) {
      const firstLine = []
      const secondLine = []
      const x = []
      let map = {
        0: {
          firstLineName: 'num',
          secondLineName: 'beforeNum'
        },
        1: {
          firstLineName: 'num',
          secondLineName: 'beforeNum'
        },
        2: {
          firstLineName: 'num',
          secondLineName: 'beforeNum'
        },
        3: {
          firstLineName: 'num',
          secondLineName: 'beforeNum'
        },
        4: {
          firstLineName: 'num',
          secondLineName: 'beforeNum'
        }
      }
      const fln = map[this.dataType].firstLineName
      const sln = map[this.dataType].secondLineName
      list.forEach(item => {
        let fl = item[fln]
        let sl = item[sln]
        if (this.isMissRate) { // 跳失率
          fl = fl.substr(0, fl.length - 1)
          sl = this.isNow && sl.substr(0, sl.length - 1)
        }
        firstLine.push(fl)
        secondLine.push(sl)
        x.push(item.name)
      })
      switch (this.timeType) {
        case 0:
          this.xAxisNames = x.map(item => item.slice(0, 5))
          break
        case 1:
        case 2:
        case 3:
          this.xAxisNames = x
          break
      }
      const name = columnMap[this.dataType].find(item => item.prop === fln).label
      const doubleLineFlag = this.isNow || this.isQueueCar
      const dataList = [
        {
          name: doubleLineFlag ? name : name.slice(2),
          type: this.visualType,
          data: firstLine,
          smooth: this.isMissRate
        }
      ]
      if (doubleLineFlag) {
        dataList.push({
          name: columnMap[this.dataType].find(item => item.prop === sln).label,
          type: this.visualType,
          data: secondLine,
          smooth: this.isMissRate
        })
      }
      this.dataList = dataList
    },
    batchExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = this.formatParams()
        this.exportDataBoardFlowSurvey(params).then(res => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '统计数据.xls'
            // 兼容 IE系列 浏览器
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.time-container{
  padding-bottom: 50px;
}
.select{
  position: absolute;
  left: 0;
  top: 40px;
}
.date-picker{
  position: absolute;
  right: 0;
  top: 40px;
}
.echart-line-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80vh;
  margin: 20px auto;
}
</style>
